// extracted by mini-css-extract-plugin
var _1 = "HistorySidebar-module__active--G5w0q";
var _2 = "HistorySidebar-module__animateUploadProgressBarWidth--LIGSe";
var _3 = "HistorySidebar-module__animatedBackground--Ew9gx";
var _4 = "HistorySidebar-module__closeButtonContainer--g3Eh2";
var _5 = "HistorySidebar-module__content--rhChS";
var _6 = "HistorySidebar-module__tab--cPQn0";
var _7 = "HistorySidebar-module__tabs--RItHC";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "closeButtonContainer", _5 as "content", _6 as "tab", _7 as "tabs" }
